module.exports = __webpack_public_path__ + "images/Crest16a6d474a25803cad1c2667b52155d6a.jpg";